import Act from "../actions";
import themeConfig from "../../theme/config/config";

const lightDarkMode = {
  light: "light",
  dark: "dark",
};

const initState = {
  // fontSizeScale 對照表請見 src/theme/config.js
  fontSizeScale: themeConfig.htmlFontSizeConfig.normal,
  lightDarkMode: lightDarkMode.light,
};

const themeReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.THEME_SET_FONT_SIZE_SCALE:
      return { ...state, fontSizeScale: action.payload };
    case Act.THEME_SET_LIGHT_DARK_MODE:
      return { ...state, lightDarkMode: action.payload };
    default:
      return state;
  }
};

export default themeReducer;
